import Contact from './components/Contact';
// @ts-ignore
import PixelParticles from './components/PixelParticles';
import Projects from './components/Projects';
import LegalPage from './components/LegalPage';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';

function HomePage() {
  return (
    <>
      <header className="header">
        <h1>Bit Overloaded</h1>
        <h2 className="subheadline">Over-engineering at its finest</h2>
      </header>
      
      <Projects />
      <Contact />
    </>
  );
}

// Create a separate component for the app content to access useLocation
function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <div className="app">
      {isHomePage && (
        <div className="background-particles">
          <PixelParticles 
            count={150} 
            speed={0.4} 
            minSize={2} 
            maxSize={6}
            colors={[
              'rgba(255, 44, 85, 0.5)',
              'rgba(255, 140, 44, 0.5)',
              'rgba(255, 220, 44, 0.4)',
              'rgba(255, 255, 255, 0.3)'
            ]}
          />
        </div>
      )}
      
      {/* Only show the main navbar on the home page */}
      {isHomePage && (
        <nav className="navbar">
          <div className="logo-container">
            <Link to="/" className="logo-link">
              <img src="/logo.svg" alt="Logo" className="logo-img" />
            </Link>
          </div>
          <div className="nav-links">
            <Link to="/" onClick={() => scrollToSection('projects')} className="nav-link">Projects</Link>
            <Link to="/" onClick={() => scrollToSection('contact')} className="nav-link">Contact</Link>
          </div>
        </nav>
      )}
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        
        {/* Legal pages */}
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/cookies" element={<LegalPage type="cookies" />} />
      </Routes>
      
      {/* Footer Section */}
      {isHomePage && (
        <footer className="app-footer">
          <div className="app-footer-container simplified">
            <div className="legal-container">
              <p className="copyright">© {new Date().getFullYear()} Bit Overloaded. All rights reserved.</p>
              <div className="legal-links">
                <Link to="/privacy" className="legal-link">Privacy Policy</Link>
                {/* <Link to="/terms" className="legal-link">Terms of Service</Link> */}
                {/* <Link to="/cookies" className="legal-link">Cookie Policy</Link> */}
              </div>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App; 